// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vx_a bhm_b"};